import { React, Row, Alert, PropTypes, FelaComponent, Divider, get } from '../dependencies';
import SelectRestaurantsItem from './SelectRestaurantsItem';
import { restaurantWithSelectedShape } from './propTypes';
import PanelToggleItem from './PanelToggleItem';

const dividerRule = () => ({
    margin: '10px 0',
});

const warningRule = () => ({
    margin: '0 -10px',
});

const SelectRestaurantsList = ({ restaurants, toggleRestaurantSelected, toggleAllRestaurantsSelected }) => {
    const areAllSelected = restaurants.every(({ isSelected }) => isSelected);
    return (
        <Row>
            <PanelToggleItem
                title="Všechny restaurace"
                isSelected={areAllSelected}
                onToggle={() => toggleAllRestaurantsSelected(!areAllSelected)}
                small
            />
            <FelaComponent rule={dividerRule} render={Divider} />
            {restaurants.map((restaurant, i) => {
                const isFirstWithoutParser = !restaurant.hasParser && get(restaurants, [i - 1, 'hasParser'], false);
                const item = (
                    <SelectRestaurantsItem key={restaurant.id} {...restaurant} onToggle={toggleRestaurantSelected} />
                );

                return isFirstWithoutParser ? (
                    <React.Fragment key={`wrapper${restaurant.id}`}>
                        <FelaComponent
                            rule={warningRule}
                            render={({ className }) => (
                                <Alert
                                    className={className}
                                    message="Nedostupné menu"
                                    description="Restaurace níže zatím nemají přiřazeny žádný parser - jejich menu není možné zobrazit"
                                    type="warning"
                                    showIcon
                                />
                            )}
                        />
                        {item}
                    </React.Fragment>
                ) : (
                    item
                );
            })}
        </Row>
    );
};

SelectRestaurantsList.propTypes = {
    restaurants: PropTypes.arrayOf(PropTypes.shape(restaurantWithSelectedShape)),
    toggleRestaurantSelected: PropTypes.func.isRequired,
    toggleAllRestaurantsSelected: PropTypes.func.isRequired,
};

SelectRestaurantsList.defaultProps = {
    restaurants: [],
};

export default SelectRestaurantsList;
